import styled from 'styled-components'

// Superfície de conteúdo do DS: ocupa toda a largura do <Main> (que dá o
// respiro lateral simétrico), raio de card 20px e padding 24px (16px no mobile).
export const Container = styled.div`
    width: 100%;
    min-width: 0;
    background-color: ${({ theme }) => theme.colors.container.background};
    margin: 16px 0;
    padding: 24px;
    border-radius: 20px;
    position: relative;
    @media (max-width: 768px) {
        margin: 12px 0;
        padding: 16px;
        border-radius: 16px;
    }
`

export const ContainerHeader = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 16px;
    align-items: center;
    margin-bottom: 16px;
`
